import { render, staticRenderFns } from "./PoliticalParties.vue?vue&type=template&id=12ffe76a&scoped=true&"
import script from "./PoliticalParties.vue?vue&type=script&lang=js&"
export * from "./PoliticalParties.vue?vue&type=script&lang=js&"
import style0 from "./PoliticalParties.vue?vue&type=style&index=0&id=12ffe76a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ffe76a",
  null
  
)

export default component.exports